import DiscountBadge from 'src/components/Icons/DiscountBadge'
import { TurboPickupChevronRightIcon } from 'src/components/Icons/TurboPickupChevronRightIcon'
import FlexibleLink from 'src/components/ui/FlexibleLink/FlexibleLink'

type TurboPickupFlagProps = {
  text: string
  linkUrl?: string
}

export function TurboPickupFlag({ text, linkUrl }: TurboPickupFlagProps) {
  return (
    <div className="flex flex-col mt-1.5 max-w-[90%]">
      <span
        data-testid="turbo-pickup-flag"
        className="gap-1 inline-flex items-start px-2 py-0.5 bg-turboPickupFlagBg text-font-size-2 font-medium text-turboPickupFlagText break-words"
      >
        <span className="shrink-0 flex items-center h-[18px]">
          <DiscountBadge color="#01684C" aria-hidden="true" />
        </span>
        {text}
      </span>
      {linkUrl && (
        <div className="flex items-center gap-2 mt-[9px]">
          <FlexibleLink
            linkUrl={linkUrl}
            label="Saiba mais sobre a promoção"
            classNames="text-primaryBlue text-font-size-3 font-semibold"
          />
          <TurboPickupChevronRightIcon
            color="#3643BA"
            width={16}
            height={16}
            aria-hidden="true"
          />
        </div>
      )}
    </div>
  )
}
